import { useEffect, useRef } from 'react';

export function useHorizontalWheelScroll<T extends HTMLElement>() {
	const ref = useRef<T>(null);

	useEffect(() => {
		const el = ref.current;
		if (!el) return;

		const onWheel = (e: WheelEvent) => {
			if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;

			const maxScroll = el.scrollWidth - el.clientWidth;
			if (maxScroll <= 0) return;

			const prev = el.scrollLeft;
			const next = Math.max(0, Math.min(maxScroll, prev + e.deltaY));
			if (next === prev) return;

			el.scrollLeft = next;
			e.preventDefault();
		};

		el.addEventListener('wheel', onWheel, { passive: false });
		return () => el.removeEventListener('wheel', onWheel);
	}, []);

	return ref;
}
